export default __webpack_public_path__ + "static/media/Easter.f4d5dc5e.jpg";